module.exports = __webpack_public_path__ + "static/media/49.b080526b.png";